/* Managed filter values */
// export type FilterType = 'term' | 'match' | 'range';

/* Single filter field (name, value) */
export type FilterField = string;
export type FilterValue = string | number | Array<Object>;

/* Operators used for 'range' type filterings */
export type RangeFilterOperators = 'gt' | 'gte' | 'lt' | 'lte';

/* Managed filter clauses */
// export type TermFilters = Map<FilterField, FilterValue>;
// export type MatchFilters = Map<FilterField, FilterValue>;
// export type OperatorsClause = Map<RangeFilterOperators, FilterValue>;
// export type RangeFilters = Map<FilterField, OperatorsClause>;
// export type FilterClause = TermClause | MatchClause | RangeClause;

export type TermFilters = Object;
export type MatchFilters = Object;
export type RangeFilters = Object;

export class ListFilters {

//    private filters: Map<FilterType, FilterClause> = new Map<FilterType, FilterClause>([
//        ['term', new Map<FilterField, FilterValue>()],
//        ['match', new Map<FilterField, FilterValue>()],
//        ['range', new Map<FilterField, OperatorsClause>()]
//    ]);

    private termFilters: TermFilters;
    private matchFilters: MatchFilters;
    private rangeFilters: RangeFilters;

    constructor() {
        this.initAllFilters();
    }

    initAllFilters(): void {
        this.termFilters = new Object();
        this.matchFilters = new Object();
        this.rangeFilters = new Object();
    }

    private isEmptyFilters(filters: Object): boolean {
        return Object.keys(filters).length === 0;
    }

    addTermFilter(field: FilterField, value: FilterValue) {
        this.termFilters[field] = value;
    }

    addMatchFilter(field: FilterField, value: FilterValue) {
        this.matchFilters[field] = value;
    }

    addRangeFilter(field: FilterField, operator: RangeFilterOperators, value: FilterValue) {
        if (!this.rangeFilters[field]) {
            this.rangeFilters[field] = new Object();
        }
        this.rangeFilters[field][operator] = value;
    }

    removeTermFilter(field: FilterField) {
        delete this.termFilters[field];
    }

    removeMatchFilter(field: FilterField) {
        delete this.matchFilters[field];
    }

    removeRangeFilter(field: FilterField) {
        delete this.rangeFilters[field];
    }

    getAllFilters(): Object {
        const filters: Object = new Object();
        if (!this.isEmptyFilters(this.termFilters)) {
            filters['term'] = this.termFilters;
        }
        if (!this.isEmptyFilters(this.matchFilters)) {
            filters['match'] = this.matchFilters;
        }
        if (!this.isEmptyFilters(this.rangeFilters)) {
            filters['range'] = this.rangeFilters;
        }
        return filters;
    }

    stringifyAllFilters(): string {
        return JSON.stringify(this.getAllFilters());
    }

}



// WEBPACK FOOTER //
// ./src/app/models/list-filters.ts